const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const usdWhole = new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0,
});

export const formatCents = (cents) => usd.format((cents ?? 0) / 100);

/** Map pins and headline rates: "$275" not "$275.00". */
export const formatCentsCompact = (cents) => usdWhole.format((cents ?? 0) / 100);

export const formatMonthly = (cents) => `${formatCentsCompact(cents)}/mo`;

export const formatDistance = (miles) =>
  miles == null ? '' : miles < 10 ? `${Number(miles).toFixed(1)} mi` : `${Math.round(miles)} mi`;

export const formatFeet = (feet) =>
  feet == null ? '—' : `${Number(feet) % 1 === 0 ? Number(feet) : Number(feet).toFixed(1)}ft`;

export const formatDimensions = (length, width) => `${formatFeet(length)} × ${formatFeet(width)}`;

export const formatAmps = (amps) => (amps?.length ? amps.map((a) => `${a}A`).join(' / ') : 'No power');

export const formatDate = (iso) =>
  iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';

export const formatMonthYear = (iso) =>
  iso ? new Date(iso).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : '';

/** "8:00 AM" from a Postgres TIME value. */
export const formatTime = (time) => {
  if (!time) return null;
  const [h, m] = time.split(':').map(Number);
  const suffix = h >= 12 ? 'PM' : 'AM';
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${suffix}`;
};

export const gateHours = (facility) => {
  if (facility.is_24h_access) return '24-hour access';
  const open = formatTime(facility.gate_opens_at);
  const close = formatTime(facility.gate_closes_at);
  return open && close ? `Gate ${open} – ${close}` : 'Gate hours vary';
};
